export function setBtnAreaConfig() {
  return [
    {label: ()=> {return '搜索'}, type: 'primary', bindClick: ()=>{this.getListCX()}, setPower: () => {return true}},
    {label: ()=> {return '重置'}, type: 'primary', bindClick: ()=>{this.resetForm('filters')}, setPower: () => {return true}},
    {label: ()=> {return '新增'}, type: 'primary', bindClick: ()=>{this.goForm('add')}, setPower: () => {return true}},
  ]
}
export function setTableConfig() {
	return {
    label: ['提交服务名称', 'Pipeline名称','运行实例主机地址', 'HDFS中ODS层的绝对路径', '创建时间', '创建人', '操作'],
    prop: ['name', 'pipelineName', 'hostName', 'odsStorePath', 'createTime', 'creatorName', 'active'
    ],
    custom: [
      {
        prop: 'name',
        width: 250
      }, {
        prop: 'pipelineName',
        width: 250
      }, {
        prop: 'odsStorePath',
        width: 300,
      }, {
        prop: 'odsStorePath',
        width: 400,
      },
      {
        prop: 'createTime',
        width: 170,
        customType: 'custom-dom',
        customRender: (scope) => {
          return `<div>${scope.row.createTime.replace(/T/g,' ')}</div>`
        }
      },
      {
        prop: 'creatorName',
        width: 100,
      },
      {
        prop: 'active',
        customType: 'table-btn',
        fixed: 'right',
        customBtnList: [
          {
            render: () => { if(this.tableData.length > 0) return '详情' },
            customBindClick: (scope) => {this.goForm('details',scope.row.id)}
          },
          {
            render: () => '修改',
            customBindClick: (scope) => {this.goForm('edit',scope.row.id)}
          },
          {
            render: () => '删除',
            customBindClick: (scope) => {this.del(scope.row.id)}
          }
        ]
      },
    ]
  }
}
